(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strght-magazine-grid"] && !Shopify.designMode) return;
  try {
    
  const sizeStrghtMarquees = () => {
    document.querySelectorAll('.strght-magazine__track').forEach(track => {
      const group = track.querySelector('span');
      if (group) track.style.setProperty('--strght-marquee-duration', (group.getBoundingClientRect().width / 14.5) + 's');
    });
  };
  document.fonts.ready.then(sizeStrghtMarquees);
  window.addEventListener('resize', sizeStrghtMarquees, { passive: true });
  document.addEventListener('shopify:section:load', sizeStrghtMarquees);

  } catch(e) { console.error(e); }
})();
})();
